import { SkeletonText } from '@dev-spendesk/grapes';
import React from 'react';

type Props = {
  count: number;
};

export const ScheduledPaymentsBatchesLoader = ({ count }: Props) => {
  return (
    <ul className="w-full">
      {Array.from({ length: count }, (_1, key1) => (
        <li key={key1}>
          <SkeletonText className="my-4" size="l" width="70px" />
          <ul>
            {Array.from({ length: 3 }, (_2, key2) => (
              <li className="box mb-16 p-16" key={key2}>
                <div className="mb-8 flex items-center justify-between">
                  <SkeletonText size="l" width="160px" />
                  <SkeletonText size="l" width="70px" />
                </div>
                <div className="flex items-center justify-between">
                  <SkeletonText size="s" width="250px" />
                  <SkeletonText size="s" width="150px" />
                </div>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};
